import { useMemo } from 'react';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch-hooks-web';
import config from '../config/config';

const useSearchHasRefinement = () => {
	const { items, canRefine, refine } = useCurrentRefinements();
	const api = useInstantSearch();
	const filterString = api.indexUiState.configure?.filters || '';

	const hasRefinementStatus = useMemo( () => {
		const attributes = items.map( ( item ) => item.attribute );
		const hasStatus = attributes.includes( config.FILTER_ATTRIBUTES.availability );
		const hasMoveInWindow = attributes.includes( config.FILTER_ATTRIBUTES.moveInWindow );
		return hasStatus || hasMoveInWindow;
	}, [ items ] );

	const hasCurrentRefinementHomeDetails = useMemo( () => {
		const attributes = items.map( ( item ) => item.attribute );
		const hasSqFt = filterString.includes( 'sq_feet' );
		const hasBedrooms = filterString.includes( 'bedrooms' );
		const hasBathrooms = filterString.includes( 'bathrooms' );
		const hasGarages = filterString.includes( 'garage' );
		const hasRv = attributes.includes( config.FILTER_ATTRIBUTES.garageRV );
		const hasPlanType = attributes.includes( config.FILTER_ATTRIBUTES.homeType );
		const hasModelHome = attributes.includes( config.FILTER_ATTRIBUTES.modelTour );
		const hasHomeFeatures = attributes.includes( config.FILTER_ATTRIBUTES.homeFeature );
		return hasSqFt || hasBedrooms || hasBathrooms || hasGarages || hasRv || hasPlanType || hasModelHome || hasHomeFeatures;
	}, [ items, filterString ] );

	const hasCurrentRefinementPrice = useMemo( () => {
		return filterString.includes( 'price' );
	}, [ filterString ] );

	const hasRefinementMore = useMemo( () => {
		const attributes = items.map( ( item ) => item.attribute );
		const hasTour = attributes.includes( config.FILTER_ATTRIBUTES.tourOption );
		const hasNeighborhood = attributes.includes( config.FILTER_ATTRIBUTES.neighborhoodType );
		const hasAmenity = attributes.includes( config.FILTER_ATTRIBUTES.amenity );
		const hasSchool = attributes.includes( config.FILTER_ATTRIBUTES.schoolDistrict );
		return hasTour || hasNeighborhood || hasAmenity || hasSchool;
	}, [ items ] );

	return {
		hasRefinementStatus,
		hasCurrentRefinementHomeDetails,
		hasCurrentRefinementPrice,
		hasRefinementMore,
		hasRefinement: hasRefinementStatus || hasCurrentRefinementHomeDetails || hasCurrentRefinementPrice || hasRefinementMore,
	};
};

export default useSearchHasRefinement;
